export default "__VITE_ASSET__3bac0b92__"